// client/src/utils/documents.js
// Display details for the admin's manually created documents (see the
// /api/admin/documents routes) - one shape shared by invoices, quotes, and
// proforma invoices.
export const DOCUMENT_TYPES = {
  invoice: {
    label: 'Invoice',
    plural: 'Invoices',
    heading: 'TAX INVOICE',
    listPath: '/admin/invoices',
    statuses: ['unpaid', 'paid', 'cancelled'],
    dueLabel: 'Due date',
    footer: 'Thank you for your business.',
  },
  quote: {
    label: 'Quote',
    plural: 'Quotes',
    heading: 'QUOTATION',
    listPath: '/admin/quotes',
    statuses: ['draft', 'sent', 'accepted', 'declined', 'expired'],
    dueLabel: 'Valid until',
    footer: 'This quotation is not a tax invoice. Prices are subject to availability until accepted.',
  },
  proforma: {
    label: 'Proforma Invoice',
    plural: 'Proforma Invoices',
    heading: 'PROFORMA INVOICE',
    listPath: '/admin/proformas',
    statuses: ['draft', 'sent', 'paid', 'cancelled'],
    dueLabel: 'Due date',
    footer: 'This proforma invoice is not a tax invoice. A tax invoice will be issued once payment is received.',
  },
};

export const STATUS_COLORS = {
  draft: 'default',
  sent: 'info',
  accepted: 'success',
  declined: 'error',
  expired: 'warning',
  unpaid: 'warning',
  paid: 'success',
  cancelled: 'default',
};

// Mirrors the server: a paid or cancelled invoice can no longer be edited.
export const isLockedDocument = (doc) => doc.type === 'invoice' && ['paid', 'cancelled'].includes(doc.status);

export const statusLabel =(status) => status.charAt(0).toUpperCase() + status.slice(1);

export const formatDocumentDate = (isoDate) => (
  isoDate ? new Date(`${isoDate}T00:00:00`).toLocaleDateString() : '—'
);
